import { render, staticRenderFns } from "./aboutUs.vue?vue&type=template&id=04064cd7&scoped=true&"
import script from "./aboutUs.vue?vue&type=script&lang=ts&"
export * from "./aboutUs.vue?vue&type=script&lang=ts&"
import style0 from "./aboutUs.vue?vue&type=style&index=0&id=04064cd7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04064cd7",
  null
  
)

export default component.exports